<template>
  <div class="pay-deposit">
    <div class="container">
      <div class="header">
        <div class="tab-list">
          <el-tabs
            v-model="formSearch.dataType"
            @tab-click="onTabChange"
          >
            <el-tab-pane
              :name="item.value"
              :label="item.label"
              v-for="(item,index) in dataTypeData"
              :key="index"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="search-content">
          <el-form
            :inline="true"
            @submit.native.prevent
          >
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float:right;">
              <search-input
                v-model="formSearch.search"
                :placeholder="$t('payDeposit.htbhjsh')"
                @fetch="onPageChange({page:1})"
              ></search-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div
        class="query-filter"
        v-if="formSearch.dataType === '1'"
      >
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('payDeposit.qi_zu_ri_qi') }}</div>
                <div class="value">
                  <custom-date-picker
                    v-model="formSearch.rentalTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    :start-placeholder="$t('payDeposit.kai_shi_shi_jian')"
                    :end-placeholder="$t('payDeposit.jie_shu_shi_jian')"
                    @change="rentalTimeChange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  ></custom-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('payDeposit.shou_kuan_gong_si') }}</div>
                <div class="value">
                  <el-input
                    v-model="formSearch.receiveName"
                    clearable
                    :placeholder="$t('Common.com_please_input')"
                    @input="receiveNameChange"
                  ></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              closable
              v-for="tag in rentalTimeTags"
              :key="tag.value"
              @close="delRentalTimeTag"
            >{{tag.label}}</el-tag>
            <el-tag
              closable
              v-for="tag in receiveNameTags"
              :key="tag.value"
              @close="onCloseReceiveName(tag.value)"
            >{{tag.label}}</el-tag>
          </div>
        </div>
      </div>
      <div
        class="query-filter"
        v-if="formSearch.dataType === '2'"
      >
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('payDeposit.qi_zu_ri_qi') }}</div>
                <div class="value">
                  <custom-date-picker
                    v-model="formSearch.rentalTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    :start-placeholder="$t('payDeposit.kai_shi_shi_jian')"
                    :end-placeholder="$t('payDeposit.jie_shu_shi_jian')"
                    @change="rentalTimeChange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  ></custom-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('payDeposit.tui_kuan_gong_si') }}</div>
                <div class="value">
                  <el-input
                    v-model="formSearch.receiveName"
                    clearable
                    :placeholder="$t('Common.com_please_input')"
                    @input="receiveNameChange"
                  ></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              closable
              v-for="tag in rentalTimeTags"
              :key="tag.value"
              @close="delRentalTimeTag"
            >{{tag.label}}</el-tag>
            <el-tag
              closable
              v-for="tag in receiveNameTags"
              :key="tag.value"
              @close="onCloseReceiveName(tag.value)"
            >{{tag.label}}</el-tag>
          </div>
        </div>
      </div>
      <div
        class="query-filter"
        v-if="formSearch.dataType === '3'"
      >
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('payDeposit.tui_kuan_ri_qi') }}</div>
                <div class="value">
                  <custom-date-picker
                    v-model="formSearch.refundTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    :start-placeholder="$t('payDeposit.kai_shi_shi_jian')"
                    :end-placeholder="$t('payDeposit.jie_shu_shi_jian')"
                    @change="refundTimeChange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  ></custom-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('payDeposit.tui_kuan_gong_si') }}</div>
                <div class="value">
                  <el-input
                    v-model="formSearch.receiveName"
                    clearable
                    :placeholder="$t('Common.com_please_input')"
                    @input="receiveNameChange"
                  ></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              closable
              v-for="tag in refundTimeTags"
              :key="tag.value"
              @close="delRefundTimeTag"
            >{{tag.label}}</el-tag>
            <el-tag
              closable
              v-for="tag in receiveNameTags"
              :key="tag.value"
              @close="onCloseReceiveName(tag.value)"
            >{{tag.label}}</el-tag>
          </div>
        </div>
      </div>
      <div class="table-bd">
        <custom-table
          :key="formSearch.dataType"
          :tableCode="tableCode"
          height="400px"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          :slots="['rentalTerm','action']"
          @filter="filterChange"
          @sort="sortChange"
        >
          <template v-slot:rentalTerm="scope">
            {{formatRentalTerm(scope.row)}}
          </template>
          <template v-slot:action="scope">
            <span class="action-content">
              <span
                class="btn-content"
                v-if="formSearch.dataType === '1' && scope.row.billTradeState !== 0"
              >
                <el-button
                  v-if="funcView.account_check_payment_record"
                  type="text"
                  size="mini"
                  @click="checkPaymentInfo(scope.row)"
                >{{ $t('payDeposit.fu_kuan_xiang_qing') }}</el-button>
              </span>
              <span
                class="btn-content"
                v-if="formSearch.dataType === '3'"
              >
                <el-button
                  v-if="funcView.account_check_refund_msg"
                  type="text"
                  size="mini"
                  @click="watchRefundRecord(scope.row)"
                >{{ $t('payDeposit.tui_kuan_xiang_qing') }}</el-button>
              </span>
              <!-- 申请退款 -->
              <span
                class="btn-content"
                v-if="formSearch.dataType === '1' && scope.row.billTradeState === 10 && (scope.row.bizState === 45 || scope.row.bizState === 43)"
              >
                <el-button
                  v-if="funcView.account_apply_refund"
                  type="text"
                  size="mini"
                  @click="onToRefund(scope.row)"
                >
                {{ $t('payDeposit.shen_qing_tui_kuan') }}
                </el-button>
              </span>
            </span>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
          :sizes="false"
          radius
        ></custom-pagination>
      </div>
    </div>
    <refund-record-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
    ></refund-record-dialog>
    <!-- 申请退款（押金） -->
    <deposit-refund-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getTableList"
    ></deposit-refund-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import mixins from './children/mixins';
import refundRecordDialog from './children/refund_record_dialog.vue';
import depositRefundDialog from './children/deposit_refund_dialog.vue';

// i18n-lang-component
export default {
  name: '',
  mixins: [mixins],
  components: {
    refundRecordDialog,
    depositRefundDialog
  },
  props: {
  },
  data() {
    return {
      formSearch: {
        dataType: '',
        pageSize: 50,
        pageNum: 1,
        search: '',
        // 启租日期
        rentalTime: [],
        // 退款日期
        refundTime: [],
        // 收款/退款公司
        receiveName: '',
        type: 1,
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      rentalTimeTags: [],
      refundTimeTags: [],
      receiveNameTags: [],
    };
  },
  computed: {
    dataTypeData() {
      return [
        {
          label: this.$t('payDeposit.ying_fu_ya_jin'),
          value: '1'
        },
        {
          label: this.$t('payDeposit.tui_kuan_zhong'),
          value: '2'
        },
        {
          label: this.$t('payDeposit.yi_tui_kuan'),
          value: '3'
        }
      ];
    },
    tableCode() {
      if (`${this.formSearch.dataType}` === '1') {
        return 'portal_payable_deposit';
      }
      if (`${this.formSearch.dataType}` === '2') {
        return 'portal_refunding_deposit';
      }
      if (`${this.formSearch.dataType}` === '3') {
        return 'portal_refund_deposit';
      }

      return '';
    }
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    // 清除查询参数(dataType除外)
    clearQueryParams() {
      this.$setFormatData(this.formSearch, {
        pageSize: 50,
        pageNum: 1,
        search: '',
        // 启租日期
        rentalTime: [],
        // 退款日期
        refundTime: [],
        // 收款/退款公司
        receiveName: '',
      });
    },
    delRentalTimeTag() {
      this.formSearch.rentalTime = [];
      this.formSearch.pageNum = 1;
      this.rentalTimeTags = [];
      this.getTableList();
    },
    delRefundTimeTag() {
      this.formSearch.refundTime = [];
      this.formSearch.pageNum = 1;
      this.refundTimeTags = [];
      this.getTableList();
    },
    rentalTimeChange() {
      const data = this.formSearch.rentalTime;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.rentalTimeTags = [
          {
            label: `${start}~${end}`,
            value: 'rentalTime'
          }
        ];
      } else {
        this.rentalTimeTags = [];
      }
      this.onPageChange({ page: 1 });
    },
    refundTimeChange() {
      const data = this.formSearch.refundTime;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.refundTimeTags = [
          {
            label: `${start}~${end}`,
            value: 'refundTime'
          }
        ];
      } else {
        this.refundTimeTags = [];
      }
      this.onPageChange({ page: 1 });
    },
    receiveNameChange() {
      const receiveName = this.formSearch.receiveName.trim();
      if (receiveName) {
        this.receiveNameTags = [
          {
            label: receiveName,
            value: 'receiveName'
          }
        ];
      } else {
        this.receiveNameTags = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseReceiveName() {
      this.formSearch.receiveName = '';
      this.receiveNameTags = [];
      this.onPageChange({ page: 1 });
    },
    // 申请退款（押金）
    onToRefund(billData) {
      this.dialogModel2 = {
        data: billData,
        title: this.$t('payDeposit.shen_qing_tui_ya_jin')
      };
      this.dialogVisible2 = true;
    },
    clearTagList() {
      this.rentalTimeTags = [];
      this.refundTimeTags = [];
      this.receiveNameTags = [];
    },
    onTabChange() {
      this.clearQueryParams();
      this.clearTagList();
      this.getTableList();
    },
    // 查看-退款信息
    watchRefundRecord: function (row) {
      this.dialogModel.type = 'watch';
      this.dialogModel.title = this.$t('payDeposit.tui_kuan_xiang_qing');
      this.dialogModel.row = row;
      this.dialogVisible = true;
    },
    getReqListData() {
      const ret = {
        ...this.formSearch
      };
      const { rentalTime, refundTime } = this.formSearch;
      if (rentalTime && rentalTime.length) {
        ret.rentalStartDate = rentalTime[0];
        ret.rentalEndDate = rentalTime[1];
      }
      if (refundTime && refundTime.length) {
        ret.refundStartDate = refundTime[0];
        ret.refundEndDate = refundTime[1];
      }
      delete ret.rentalTime;
      delete ret.refundTime;
      return ret;
    },
    // 获取表格数据
    getTableList: function () {
      const reqData = this.getReqListData();
      this.$getJSON(apis.DepositPage, reqData).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total || null;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    formatRentalTerm(row) {
      const { rentalTerm, rentalTermUnit } = row;
      if (rentalTermUnit) {
        const map = this.dicValueName.rental_term_unit;
        if (map && map[rentalTermUnit]) {
          return `${rentalTerm}${map[rentalTermUnit]}`;
        }
      }
      return rentalTerm;
    },
  },
  created() {
  },
  mounted() {
    this.formSearch.dataType = '1';
    this.getFuncView('/rent/myAccount');
    this.getDictionaryValueName('rental_term_unit', () => {
      this.getTableList();
    });
  },
};
</script>

<style lang="scss" scoped>
.pay-deposit {
  padding: 24px;
  padding-bottom: 0;

  .search-content{
    overflow: hidden;
  }

  > .container {
    padding: 24px;
    background: #fff;
    border-radius: 16px;
    background: #fff;
  }

  .query-filter {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
  }

  .btn-content {
    float: left;
    padding-right: 10px;
  }

  > .header {
    // padding: 24px;
    overflow: hidden;
    padding-bottom: 0;
    .tab-list {
      float: left;
    }
    .search-content {
      float: right;
    }
  }

  .table-bd {
  }
}
</style>
